export enum Error {
  UnableLoad = 'Unable to load todos',
  EmptyTitle = 'Title should not be empty',
  UnableAdd = 'Unable to add a todo',
  UnableDelete = 'Unable to delete a todo',
  UnableUpdate = 'Unable to update a todo',
}
